import { render, staticRenderFns } from "./DataInputDatetime.vue?vue&type=template&id=56b727d2&scoped=true&"
import script from "./DataInputDatetime.vue?vue&type=script&lang=js&"
export * from "./DataInputDatetime.vue?vue&type=script&lang=js&"
import style0 from "./DataInputDatetime.vue?vue&type=style&index=0&id=56b727d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b727d2",
  null
  
)

export default component.exports